import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class ExpenseService {
  constructor(private http: HttpClient, private restService: RestService) {}
  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('expense/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('expense/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('expense/save', data);
  }

  saveCommissionBooking(data: any) {
    return this.restService.save('money/expense/save/commision', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('expense/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('expense/delete', val_id);
  }
}
